const mapKeys = (fn, obj) => {
  const result = {};
  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      result[fn(key)] = obj[key];
    }
  }
  return result;
};
export {
  mapKeys as m
};
